module.exports = __webpack_public_path__ + "img/new-gray.23c19f6f.svg";